<template>
  <div class="separation-anxiety">
    <separation-anxiety-card />
    <separation-anxiety-mission-possible-card />
    <separation-anxiety-do-it-yourself-card />
  </div>
</template>

<script>
import SeparationAnxietyCard from '../cards/SeparationAnxietyCard'
import SeparationAnxietyMissionPossibleCard from '../cards/SeparationAnxietyMissionPossibleCard'
import SeparationAnxietyDoItYourselfCard from '../cards/SeparationAnxietyDoItYourselfCard'

const setOpenGraphMeta = require('./_helpers/openGraph.js')

export default {
  name: 'separation-anxiety',
  components: {
    SeparationAnxietyCard,
    SeparationAnxietyMissionPossibleCard,
    SeparationAnxietyDoItYourselfCard,
  },
  mounted () {
    setOpenGraphMeta({
      ogUrl: 'https://www.rewardingdogtraining.com/services/separation-anxiety',
      ogTitle: 'Separation Anxiety - Rewarding Dog Training',
      ogDescription: 'Tackle your dog\'s separation anxiety with our hands on coaching, do it yourself program, or a hybrid model',
    })
  },
}
</script>

<style lang="scss">
.basic-manners {
  width: 100%;
}
</style>
